import DialogActionCancelSubmit from "@/components/shared/dialog/dialog-action-cancel-submit";
import DialogWrapper from "@/components/shared/dialog/dialog-wrapper";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Trans, useTranslation } from "react-i18next";

export default function ResendUserInviteDialog({
	username,
	open_resend_dialog,
	set_open_resend_dialog,
	on_submit_handler = () => {},
}) {
	const { t } = useTranslation();

	return (
		<DialogWrapper
			open={open_resend_dialog}
			close_button
			on_close={() => set_open_resend_dialog(false)}
			title={t("administrator.user_management.pending.resend_modal.title")}
			max_width="sm"
		>
			<Trans
				i18nKey="administrator.user_management.pending.resend_modal.description"
				values={{ username: username }}
			/>
			<DialogActionCancelSubmit
				on_close={() => set_open_resend_dialog(false)}
				on_submit={on_submit_handler}
				on_submit_icon={<ArrowForwardIcon />}
				on_submit_text={t("buttons.resend")}
			/>
		</DialogWrapper>
	);
}
